import { render } from "./NouveauClient.vue?vue&type=template&id=6430a787&scoped=true"
import script from "./NouveauClient.vue?vue&type=script&lang=js"
export * from "./NouveauClient.vue?vue&type=script&lang=js"

import "./NouveauClient.vue?vue&type=style&index=0&id=6430a787&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6430a787"]])

export default __exports__